import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import { OfferService } from '@/services/rtps/offer.service';

import {
    ERROR_HANDLE_ERROR,
    ERROR_CLEAR_ERROR
} from '../error/actions.type';

import {
  OFFER_CREATE,
  OFFER_SEARCH,
  OFFER_GET,
  OFFER_ADD_NDC,
  OFFER_REMOVE_NDC,
  OFFER_ADD_STATE_EXCLUSION,
  OFFER_REMOVE_STATE_EXCLUSION,
  OFFER_ADD_SEGMENT,
  OFFER_REMOVE_SEGMENT,
  OFFER_SAVE_SEGMENT,
  OFFER_APPROVE,
  OFFER_CANCEL,
  OFFER_PUBLISH,
  OFFER_REQUESTAPPROVAL,
  OFFER_ADD,
  OFFER_SAVE,
  OFFER_LOAD_GLOBAL_PRODUCT_LISTS,
  OFFER_LOAD_GLOBAL_LISTS,
  OFFER_LOAD_PORTAL_LISTS
} from './actions.type';
import {
  SET_OFFER_GET,
  SET_OFFER_SEARCH,
  SET_OFFER_BUSY,
  SET_OFFER_ADD_NDC,
  SET_OFFER_REMOVE_NDC,
  SET_OFFER_ADD_STATE_EXCLUSION,
  SET_OFFER_REMOVE_STATE_EXCLUSION,
  SET_OFFER_ADD_SEGMENT,
  SET_OFFER_REMOVE_SEGMENT,
  SET_OFFER_SAVE_SEGMENT,
  SET_OFFER_NAME,
  SET_OFFER_DRUG_NAME,
  SET_OFFER_GLOBAL_PRODUCT_LIST_ID,
  SET_OFFER_GLOBAL_LIST_ID,
  SET_OFFER_PHARMA_CLIENT,
  SET_OFFER_EFFECTIVE_DATE,
  SET_OFFER_END_DATE,
  SET_OFFER_MANUFACTURE,
  SET_OFFER_IS_PENDING_INACTIVATION,
  SET_OFFER_MINIMUM_AGE,
  SET_OFFER_MAXIMUM_AGE,
  SET_OFFER_PROGRAM_ID,
  SET_OFFER_COMMENTS,
  SET_OFFER_GLOBAL_PRODUCT_LISTS_LOADING,
  SET_OFFER_GLOBAL_LISTS_LOADING,
  SET_OFFER_GLOBAL_PRODUCT_LISTS,
  SET_OFFER_GLOBAL_LISTS,
  SET_OFFER_PORTAL_LISTS_LOADING,
  SET_OFFER_PORTAL_LISTS
} from './mutations.type';

const templateOffer = {
    offer_status_text: "new",
    is_pending_inactivation: false,
    ndc_num: [],
    segments: [],
    offer_effective_date: "",
    offer_end_date: "",
    state_exclusion_list_array: []
};

const initialState = {
    searchCriteria: {},
    searchResults: { total: 0, records: [] },
    isSearchBusy: false,
    isBusy: false,
    currentOffer: {},
    states: {
        "AL": "Alabama",
        "AK": "Alaska",
        "AS": "American Samoa",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FM": "Federated States Of Micronesia",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MH": "Marshall Islands",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "MP": "Northern Mariana Islands",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PW": "Palau",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VI": "Virgin Islands",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
    },
    isLoadingGlobalProductLists: false,
    globalProductLists: [],
    isLoadingGlobalLists: false,
    globalLists: [],
    isLoadingPortalLists: false,
    portalLists: []
};

export const state = Object.assign({}, initialState);

export const actions = {
    [OFFER_CREATE](context, params) {
        context.commit(SET_OFFER_GET, {
            offer_type_text: params.offer_type_text,
            offer_minimum_age_num: 0,
            offer_maximum_age_num: 64
        });
    },
    [OFFER_SEARCH](context) {
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.query(store.getters.cognitoRoles)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_OFFER_SEARCH, data);
                }
                context.commit(SET_OFFER_BUSY, false);
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_GET](context, params) {
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.get(params.copay_offer_id, params.viewActive, store.getters.cognitoRoles)
            .then(({ data }) => {
                context.commit(SET_OFFER_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_OFFER_GET, data);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_ADD_NDC](context, ndc) {
        context.commit(SET_OFFER_ADD_NDC, ndc);
    },
    [OFFER_REMOVE_NDC](context, ndc) {
        context.commit(SET_OFFER_REMOVE_NDC, ndc);
    },
    [OFFER_ADD_STATE_EXCLUSION](context, stateCode) {
        context.commit(SET_OFFER_ADD_STATE_EXCLUSION, stateCode);
    },
    [OFFER_REMOVE_STATE_EXCLUSION](context, stateCode) {
        context.commit(SET_OFFER_REMOVE_STATE_EXCLUSION, stateCode);
    },
    [OFFER_ADD_SEGMENT](context, segment) {
        context.commit(SET_OFFER_ADD_SEGMENT, segment);
    },
    [OFFER_REMOVE_SEGMENT](context, segment) {
        context.commit(SET_OFFER_REMOVE_SEGMENT, segment);
    },
    [OFFER_SAVE_SEGMENT](context, segment) {
        context.commit(SET_OFFER_SAVE_SEGMENT, segment);
    },
    [OFFER_ADD](context, offer) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.add(offer)
            .then(({ data }) => {
                context.commit(SET_OFFER_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_OFFER_GET, data);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_SAVE](context, offer) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.save(offer)
            .then(({ data }) => {
                context.commit(SET_OFFER_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_OFFER_GET, data);
                }
                return true;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                    return false;
                });
    },
    [OFFER_REQUESTAPPROVAL](context, offer) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.requestApproval(offer)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_OFFER_BUSY, false);
                } else {
                    context.dispatch(OFFER_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_APPROVE](context, offer) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.approve(offer)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_OFFER_BUSY, false);
                } else {
                    context.dispatch(OFFER_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_PUBLISH](context, offer) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_OFFER_BUSY, true);
              
        return OfferService.publish(offer)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_OFFER_BUSY, false);
                } else {
                    context.dispatch(OFFER_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_CANCEL](context, offer) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_OFFER_BUSY, true);
        return OfferService.cancelUpdate(offer)
            .then(({ data }) => {
                context.commit(SET_OFFER_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.dispatch(OFFER_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_OFFER_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [OFFER_LOAD_GLOBAL_PRODUCT_LISTS](context) {
      let isLoadingInProgress = context.state.isLoadingGlobalProductLists || context.state.globalProductLists.length;
      if (isLoadingInProgress) {
            return;
        }

        context.commit(SET_OFFER_GLOBAL_PRODUCT_LISTS_LOADING, true);

        OfferService.getGlobalProductLists(store.getters.cognitoRoles).then(
            ({ data }) => {
                context.commit(SET_OFFER_GLOBAL_PRODUCT_LISTS_LOADING, false);
                context.commit(SET_OFFER_GLOBAL_PRODUCT_LISTS, data);
            },
            (err) => {
                context.dispatch(ERROR_HANDLE_ERROR, err);
            }
        );
    },
    [OFFER_LOAD_GLOBAL_LISTS](context) {
      let isLoadingInProgress = context.state.isLoadingGlobalLists || context.state.globalLists.length;
      if (isLoadingInProgress) {
            return;
        }

        context.commit(SET_OFFER_GLOBAL_LISTS_LOADING, true);

        OfferService.getGlobalLists(store.getters.cognitoRoles).then(
            ({ data }) => {
                context.commit(SET_OFFER_GLOBAL_LISTS_LOADING, false);
                context.commit(SET_OFFER_GLOBAL_LISTS, data);
            },
            (err) => {
                context.commit(SET_OFFER_GLOBAL_LISTS_LOADING, false);
                context.commit(SET_OFFER_GLOBAL_LISTS, []);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            }
        );
    },
    [OFFER_LOAD_PORTAL_LISTS](context) {
        let isLoadingInProgress = context.state.isLoadingPortalLists || (context.state.portalLists && context.state.portalLists.length);
        if (isLoadingInProgress) {
            return;
        }

        context.commit(SET_OFFER_PORTAL_LISTS_LOADING, true);

        OfferService.getPortals(store.getters.cognitoRoles).then(
            ({ data }) => {
                context.commit(SET_OFFER_PORTAL_LISTS_LOADING, false);
                context.commit(SET_OFFER_PORTAL_LISTS, data);
            },
            (err) => {
                context.commit(SET_OFFER_PORTAL_LISTS_LOADING, false);
                context.commit(SET_OFFER_PORTAL_LISTS, []);
                context.dispatch(ERROR_HANDLE_ERROR, err);
            }
        );
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    [SET_OFFER_SEARCH](state, results) {
        state.searchResults = results;
    },
    [SET_OFFER_BUSY](state, isBusy) {
        state.isBusy = isBusy;
    },
    [SET_OFFER_GET](state, offer) {
        const templateOfferClone = JSON.parse(JSON.stringify(templateOffer));
        // Initialize offer with expected properties from template
        state.currentOffer = { ...templateOfferClone, ...offer };
    },
    [SET_OFFER_ADD_NDC](state, ndc) {
        state.currentOffer.ndc_num.push(ndc);
    },
    [SET_OFFER_REMOVE_NDC](state, index) {
        if (index !== -1) {
            state.currentOffer.ndc_num.splice(index, 1);
        }
    },
    [SET_OFFER_ADD_STATE_EXCLUSION](state, stateCode) {
        if (state.currentOffer.state_exclusion_list_array.indexOf(stateCode) === -1) {
            state.currentOffer.state_exclusion_list_array.push(stateCode);
        }
    },
    [SET_OFFER_REMOVE_STATE_EXCLUSION](state, index) {
        if (index !== -1) {
            state.currentOffer.state_exclusion_list_array.splice(index, 1);
        }
    },
    [SET_OFFER_ADD_SEGMENT](state, segment) {
        let maxId = 0;
        if (state.currentOffer.segments && state.currentOffer.segments.length > 0) {
            var segmentIds = _.map(state.currentOffer.segments, "segment_id");
            maxId = Math.max(...segmentIds);
        }

        segment.segment_id = (maxId + 1).toString();

        if (!state.currentOffer.segments) {
            Vue.set(state.currentOffer, "segments", []);
        }
        state.currentOffer.segments.push(segment);
    },

    [SET_OFFER_REMOVE_SEGMENT](state, segment) {
        var foundSegment = _.find(state.currentOffer.segments, { segment_id: segment.segment_id });
        const index = state.currentOffer.segments.indexOf(foundSegment);
        if (index !== -1) {
            state.currentOffer.segments.splice(index, 1);
        }
    },
    [SET_OFFER_SAVE_SEGMENT](state, segment) {
        var foundSegment = _.find(state.currentOffer.segments, { segment_id: segment.segment_id });
        const index = state.currentOffer.segments.indexOf(foundSegment);

        state.currentOffer.segments.splice(index, 1, segment);
    },
    [SET_OFFER_NAME](state, value) {
        Vue.set(state.currentOffer, "copay_offer_name", value);
    },
    [SET_OFFER_DRUG_NAME](state, value) {
        Vue.set(state.currentOffer, "drug_name", value);
    },
    [SET_OFFER_GLOBAL_PRODUCT_LIST_ID](state, value) {
        Vue.set(state.currentOffer, "global_product_list_id", value);
    },
    [SET_OFFER_GLOBAL_LIST_ID](state, value) {
        Vue.set(state.currentOffer, "global_list_id", value);
    },
    [SET_OFFER_PHARMA_CLIENT](state, value) {
        Vue.set(state.currentOffer, "pharma_client", value);
    },
    [SET_OFFER_EFFECTIVE_DATE](state, value) {
        Vue.set(state.currentOffer, "offer_effective_date", value);
    },
    [SET_OFFER_END_DATE](state, value) {
        Vue.set(state.currentOffer, "offer_end_date", value);
    },
    [SET_OFFER_MANUFACTURE](state, value) {
        Vue.set(state.currentOffer, "manufacture_name", value);
    },
    [SET_OFFER_IS_PENDING_INACTIVATION](state, value) {
        Vue.set(state.currentOffer, "is_pending_inactivation", value);
    },
    [SET_OFFER_MINIMUM_AGE](state, value) {
        Vue.set(state.currentOffer, "offer_minimum_age_num", value);
    },
    [SET_OFFER_MAXIMUM_AGE](state, value) {
        Vue.set(state.currentOffer, "offer_maximum_age_num", value);
    },
    [SET_OFFER_PROGRAM_ID](state, value) {
        Vue.set(state.currentOffer, "program_id", value);
    },
    [SET_OFFER_COMMENTS](state, value) {
        Vue.set(state.currentOffer, "offer_note_change_text", value);
    },
    [SET_OFFER_GLOBAL_PRODUCT_LISTS_LOADING](state, isLoading) {
        state.isLoadingGlobalProductLists = isLoading;
    },
    [SET_OFFER_GLOBAL_PRODUCT_LISTS](state, globalProductLists) {
        state.globalProductLists = globalProductLists;
    },
    [SET_OFFER_GLOBAL_LISTS_LOADING](state, isLoading) {
        state.isLoadingGlobalLists = isLoading;
    },
    [SET_OFFER_GLOBAL_LISTS](state, globalLists) {
        state.globalLists = globalLists;
    },
    [SET_OFFER_PORTAL_LISTS_LOADING](state, isLoading) {
        state.isLoadingPortalLists = isLoading;
    },
    [SET_OFFER_PORTAL_LISTS](state, portalLists) {
        state.portalLists = Array.isArray(portalLists) ? portalLists.map(portal => ({
            ...portal,
            text: portal.text ? `${portal.text} (${portal.value})` : portal.text
        })) : [];
    }
};

const getters = {
    offerSearchResults: state => state.searchResults,
    currentOffer: state => {
        return state.currentOffer;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/offer/offer.module.js